import { TopicTakeawayTextarea } from './TopicTakeawayTextarea';
import ListTopicDetails from './listTopicDetails';
import { MeetingTopicTakeawaysTitle } from './MeetingTopicTakeawaysTitle';
import { CONVERSATION_STATUS } from '../../../src/apps/meetings/models/meeting';

export const TopicTakeSection = (props) => {
  const { meeting, meeting_topics, isConversationMeetingCompleted, isConversationMeetingClosedByHr, isConversationMeetingNotRequired, conversationStatus } = props;
  const noTopicNotedata = !((typeof meeting_topics !== 'undefined' && (meeting_topics).length > 0));
  const styleConversationCompleted = (isConversationMeetingCompleted || isConversationMeetingClosedByHr || (isConversationMeetingNotRequired && conversationStatus !== CONVERSATION_STATUS.IN_PROGRESS)) ? "conversationMarkCompleted" : "";
  return (
    <div className={styleConversationCompleted}>
      {
        meeting.status == '1' ? (
          <div className="left typing" id="topic">
            <span id="topic-text" className="topic-text-st" />
            <img className="typing-img" src={`${wbConfig.imageCdnUrl}/images/icons/typingV1.gif`} width="23px" />
          </div>
        ) : ''
      }
        <div className="TopicTakeawayContent" data-meetingid={meeting.id}>
          <MeetingTopicTakeawaysTitle />
          <div className="clear" />

          <TopicTakeawayTextarea {...props} noTopicNotedata={noTopicNotedata} />
          <div className="clear" />
          {
            (typeof meeting_topics !== 'undefined' && (meeting_topics).length > 0)
              ? <ListTopicDetails {...props} />
              : ''
          }
          <div className="clear" />
        </div>
      </div>
    );
};